const getDefaultState = () => {
  const jdUrl = localStorage.getItem('jd_url')
  const jdName = localStorage.getItem('jd_name')
  const cvUrl = localStorage.getItem('cv_url')
  const cvName = localStorage.getItem('cv_name')

  return {
    interviewDuration: 0,
    actualInterviewDuration: 0, // 新增：实际面试时长（分钟）
    interviewLanguage: '', // 新增：存储面试语言
    usingBeautifys: [],
    usingFilter: null,
    usingBackground: null,
    interviewStarted: false,
    body_language: 0,
    facial_expression: 0,
    grooming: 0,
    interview_tone: 0,
    timely_response: 0,
    content: 0,
    interviewId: '',
    recommendId: '', // 新增：存储推荐任务ID
    jd: jdUrl ? { url: jdUrl, name: jdName } : null,
    cv: cvUrl ? { url: cvUrl, name: cvName } : null,
    dialogues: [],
    firstDialogue: true,
    prompt: null,
    formattedDialogues: '', 
    rawDialogues: [],       // 新增原始对话数据备份
    processedTextBlob: null,  // 处理后的文本文件（导出面试记录用）；视频改用云端 detail.video_url
    recommendVideos: [], // 新增：视频推荐结果
    generateJsonData: null, // 新增：getGenerateJson返回的数据
    generateJsonLoading: false, // 新增：getGenerateJson加载状态
    promptLoading: false,
    promptError: null,
    linkOpenData: null, // 面试链接打开接口返回（nextAction=START_INTERVIEW 时的 data）
    currentInterviewJob: null,
    leaveScreenCount: 0, // 行为检测：不在画面中的次数（token 流程）
    multiplePeopleCount: 0, // 行为检测：画面中出现多人的次数（token 流程）
    cloudRecordTaskId: '', // 云端录制 TaskId
    cloudRecordFilePattern: '', // 云端录制文件命名 Pattern（随机生成，传给后端做关联）
    cloudRecordVideoUrl: '', // 云端录制视频地址，传给 generateInterview 的 videoUrl
    interviewStartTimestamp: 0, // 开始面试后的计时起点（毫秒时间戳），从 0 开始计时的基准
    aiSpeechSegments: [], // 每次 AI 说话的起止时间 [{ start, end }, ...]，单位为秒（相对面试开始）
  }
}



const state = getDefaultState()

const mutations = {
  SET_FORMATTED_DIALOGUES: (state, formattedText) => {
    state.formattedDialogues = formattedText
  },
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_INTERVIEW_DURATION: (state, duration) => {
    state.interviewDuration = duration
  },
  SET_ACTUAL_INTERVIEW_DURATION: (state, duration) => {
    state.actualInterviewDuration = duration
  },
  SET_INTERVIEW_LANGUAGE: (state, language) => { // 新增：设置面试语言
    state.interviewLanguage = language
  },
  SET_USING_BEAUTIFYS: (state, beautifys) => {
    state.usingBeautifys = beautifys
  },
  SET_USING_FILTER: (state, filter) => {
    state.usingFilter = filter
  },
  SET_USING_BACKGROUND: (state, background) => {
    state.usingBackground = background
  },
  SET_PROMPT(state, prompt) {
    state.prompt = prompt
  },
  SET_INTERVIEW_STARTED: (state, started) => {
    state.interviewStarted = started
    if (started) {
      state.body_language = 0
      state.facial_expression = 0
      state.grooming = 0
      while (state.dialogues.length > 0) { state.dialogues.pop() }
      state.rawDialogues = []
      state.firstDialogue = true
    }
  },
  SET_INTERVIEW_ID: (state, id) => {
    state.interviewId = id
  },
  SET_BEHAVIOR_DETECTION_COUNTS: (state, { leaveScreenCount = 0, multiplePeopleCount = 0 } = {}) => {
    state.leaveScreenCount = leaveScreenCount
    state.multiplePeopleCount = multiplePeopleCount
  },
  SET_RECOMMEND_ID: (state, id) => {
    state.recommendId = id
  },
  SET_JD: (state, jd) => {
    state.jd = jd
    // 保存URL和文件名到localStorage
    if (jd && jd.url) {
      localStorage.setItem('jd_url', jd.url)
      localStorage.setItem('jd_name', jd.name || 'job_description.txt')
    } else {
      localStorage.removeItem('jd_url')
      localStorage.removeItem('jd_name')
    }
  },
  SET_CV: (state, cv) => {
    state.cv = cv
    // 保存URL和文件名到localStorage
    if (cv && cv.url) {
      localStorage.setItem('cv_url', cv.url)
      localStorage.setItem('cv_name', cv.name || 'resume.pdf')
    } else {
      localStorage.removeItem('cv_url')
      localStorage.removeItem('cv_name')
    }
  },
  SET_DIALOGUES: (state, dialogue) => {
    if (state.firstDialogue) {
      state.firstDialogue = false
    }
    state.dialogues.push(dialogue)
    state.rawDialogues.push(dialogue) // 备份原始数据
  },
  CLEAR_DIALOGUES: (state) => {
    while (state.dialogues.length > 0) state.dialogues.pop()
    state.rawDialogues = []         // 清除原始数据
    state.formattedDialogues = ''    // 清除格式化文本
  },
  SET_PROCESSED_TEXT: (state, textBlob) => {
    state.processedTextBlob = textBlob
  },
  SET_RECOMMEND_VIDEOS: (state, videos) => {
    state.recommendVideos = Array.isArray(videos) ? videos : []
  },
  SET_GENERATE_JSON_DATA: (state, data) => {
    state.generateJsonData = data
  },
  SET_GENERATE_JSON_LOADING: (state, loading) => {
    state.generateJsonLoading = loading
  },
  SET_PROMPT_LOADING: (state, loading) => {
    state.promptLoading = loading
  },
  SET_PROMPT_ERROR: (state, error) => {
    state.promptError = error || null
  },
  SET_LINK_OPEN_DATA: (state, data) => {
    state.linkOpenData = data || null
  },
  SET_CURRENT_INTERVIEW_JOB(state, job) {
    state.currentInterviewJob = job ? { ...job } : null
  },
  CLEAR_CURRENT_INTERVIEW_JOB(state) {
    state.currentInterviewJob = null
  },
  SET_CLOUD_RECORD_INFO(state, { taskId = '', filePattern = '', videoUrl = '' } = {}) {
    state.cloudRecordTaskId = taskId ? String(taskId) : ''
    state.cloudRecordFilePattern = filePattern ? String(filePattern) : ''
    state.cloudRecordVideoUrl = videoUrl ? String(videoUrl) : ''
  },
  SET_INTERVIEW_START_TIMESTAMP(state, timestamp) {
    state.interviewStartTimestamp = timestamp || 0
  },
  SET_AI_SPEECH_START_RESET(state) {
    state.aiSpeechSegments = []
  },
  RECORD_AI_SPEECH_START(state, elapsedSeconds) {
    if (typeof elapsedSeconds !== 'number' || Number.isNaN(elapsedSeconds)) return
    const segs = state.aiSpeechSegments
    if (segs.length > 0 && segs[segs.length - 1].end === 0) return
    state.aiSpeechSegments.push({ start: elapsedSeconds, end: 0 })
  },
  RECORD_AI_SPEECH_END(state, elapsedSeconds) {
    const segs = state.aiSpeechSegments
    if (segs.length > 0 && typeof elapsedSeconds === 'number' && !Number.isNaN(elapsedSeconds)) {
      const last = segs[segs.length - 1]
      if (last.end === 0) last.end = elapsedSeconds
    }
  }
}

const actions = {
  // 仅重置与单次面试过程强相关的临时数据，避免影响面试时长等全局配置
  resetInterviewState({ commit }) {
    // 清空对话与格式化文本
    commit('CLEAR_DIALOGUES')
    // 标记未开始面试
    commit('SET_INTERVIEW_STARTED', false)
    // 清空处理后的文本（视频已改用云端 detail.video_url）
    commit('SET_PROCESSED_TEXT', null)
    // 清空推荐结果（保留 recommendId，避免打断已创建的推荐任务）
    commit('SET_RECOMMEND_VIDEOS', [])
    // 清空 prompt，避免使用上一次面试的 prompt
    commit('SET_PROMPT', null)
    commit('SET_PROMPT_ERROR', null)
    commit('SET_LINK_OPEN_DATA', null)
    commit('SET_CLOUD_RECORD_INFO', { taskId: '', filePattern: '', videoUrl: '' })
    commit('SET_INTERVIEW_START_TIMESTAMP', 0)
    commit('SET_AI_SPEECH_START_RESET')
  },
  setInterviewStartTimestamp({ commit }, timestamp) {
    commit('SET_INTERVIEW_START_TIMESTAMP', timestamp)
    commit('SET_AI_SPEECH_START_RESET')
  },
  recordAiSpeechStart({ commit, state }, elapsedSeconds) {
    if (state.interviewStartTimestamp) {
      const elapsed = typeof elapsedSeconds === 'number' ? elapsedSeconds : (Date.now() - state.interviewStartTimestamp) / 1000
      commit('RECORD_AI_SPEECH_START', elapsed)
    }
  },
  recordAiSpeechEnd({ commit, state }, elapsedSeconds) {
    if (state.interviewStartTimestamp) {
      const elapsed = typeof elapsedSeconds === 'number' ? elapsedSeconds : (Date.now() - state.interviewStartTimestamp) / 1000
      commit('RECORD_AI_SPEECH_END', elapsed)
    }
  },
  formatDialogues({ commit, state }) {
    return new Promise((resolve) => {
      let aiMessageIndex = 0
      const segs = state.aiSpeechSegments || []
      const buffer = { texts: [], firstStart: null }
      const isReminder = (text) => {
        const t = (text || '').trim()
        return t.includes('小提醒') || /^Reminder\s*[：:]?/i.test(t)
      }
      const flushInterviewer = (acc) => {
        if (buffer.texts.length === 0) return acc
        const merged = buffer.texts.join('\n\n')
        const start = buffer.firstStart
        const ts = typeof start === 'number' && !Number.isNaN(start) ? ` [timestamp:${start.toFixed(1)}]` : ''
        buffer.texts = []
        buffer.firstStart = null
        return acc + `[面试官] ${merged}${ts}\n`
      }
      const getInterviewerStart = (item) => {
        if (item && typeof item === 'object') {
          const v = item.timestampStart ?? item.timestamp ?? item.tsStart
          if (typeof v === 'number' && !Number.isNaN(v)) return v
        }
        const start = segs[aiMessageIndex]?.start
        aiMessageIndex += 1
        return start
      }

      let out = ''
      for (let i = 0; i < state.rawDialogues.length; i++) {
        const item = state.rawDialogues[i]
        if (typeof item !== 'object' || item === null) {
          out = flushInterviewer(out)
          const text = typeof item === 'string' ? item : ''
          if (text) out += `[候选人] ${text}\n`
          continue
        }
        const normalizedUserId = (item.userId || '').replace(/[＿_]/g, '')
        const isInterviewer = normalizedUserId === 'RobotMan'
        const text = `${item.text ?? ''}`
        if (isInterviewer) {
          const start = getInterviewerStart(item)
          if (isReminder(text)) {
            out = flushInterviewer(out)
            const ts = typeof start === 'number' && !Number.isNaN(start) ? ` [timestamp:${start.toFixed(1)}]` : ''
            out += `[面试官] ${text}${ts}\n`
          } else {
            buffer.texts.push(text)
            if (buffer.firstStart == null && typeof start === 'number' && !Number.isNaN(start)) buffer.firstStart = start
          }
        } else {
          out = flushInterviewer(out)
          out += `[候选人] ${text}\n`
        }
      }
      const formattedText = flushInterviewer(out).trimEnd()
      commit('SET_FORMATTED_DIALOGUES', formattedText)
      resolve(formattedText)
    })
  },
  setInterviewDuration({ commit }, duration) {
    return new Promise((resolve) => {
      commit('SET_INTERVIEW_DURATION', duration)
      resolve()
    })
  },
  setActualInterviewDuration({ commit }, duration) {
    return new Promise((resolve) => {
      commit('SET_ACTUAL_INTERVIEW_DURATION', duration)
      resolve()
    })
  },
  setInterviewLanguage({ commit }, language) { // 新增：设置面试语言
    return new Promise((resolve) => {
      commit('SET_INTERVIEW_LANGUAGE', language)
      resolve()
    })
  },
  setPrompt({ commit }, prompt) {
    commit('SET_PROMPT', prompt)
  },
  setCameraSetting({ commit }, data) {
    const { usingBeautifys, usingFilter, usingBackground } = data
    return new Promise((resolve) => {
      commit('SET_USING_BEAUTIFYS', usingBeautifys)
      commit('SET_USING_FILTER', usingFilter)
      commit('SET_USING_BACKGROUND', usingBackground)
      resolve()
    })
  },
  setInterviewId({ commit }, id) {
    return new Promise((resolve) => {
      commit('SET_INTERVIEW_ID', id)
      resolve()
    })
  },
  setRecommendId({ commit }, id) {
    return new Promise((resolve) => {
      commit('SET_RECOMMEND_ID', id)
      resolve()
    })
  },
  startInterview({ commit }) {
    return new Promise((resolve) => {
      commit('SET_INTERVIEW_STARTED', true)
      resolve()
    })
  },
  stopInterview({ commit }) {
    return new Promise((resolve) => {
      commit('SET_INTERVIEW_STARTED', false)
      resolve()
    })
  },
  setJdCv({ commit }, data) {
    const { jd, cv } = data
    return new Promise((resolve) => {
      commit('SET_JD', jd)
      commit('SET_CV', cv)
      resolve()
    })
  },
  dialogueInteract({ commit, dispatch }, data) {
    const { original_text, processed_text_from_llm } = data
    return new Promise((resolve) => {
      if (original_text != null && String(original_text).trim() !== '') {
        commit('SET_DIALOGUES', { userId: '', text: String(original_text).trim() })
      }
      if (processed_text_from_llm != null && String(processed_text_from_llm).trim() !== '') {
        commit('SET_DIALOGUES', { userId: 'RobotMan', text: String(processed_text_from_llm).trim() })
      }
      dispatch('formatDialogues').then(resolve) // 自动触发格式化
    })
  },
  clearDialogues({ commit }) {
    return new Promise((resolve) => {
      commit('CLEAR_DIALOGUES')
      resolve()
    })
  },
  dialogueFeedback({ commit }, data) {
    const { answer, feedback, question } = data
    return new Promise((resolve) => {
      commit('SET_DIALOGUES', question)
      commit('SET_DIALOGUES', answer)
      commit('SET_DIALOGUES', feedback)
      resolve()
    })
  },
  setProcessedText({ commit }, textBlob) {
    return new Promise((resolve) => {
      commit('SET_PROCESSED_TEXT', textBlob)
      resolve()
    })
  },
  async fetchGenerateJson({ commit, state }) {
    try {
      commit('SET_GENERATE_JSON_LOADING', true)
      
      // 动态导入getGenerateJson API
      const { getGenerateJson } = await import('@/api/recommend')
      
      const { data } = await getGenerateJson({
        jd_url: state.jd?.url || "",
        resume_url: state.cv?.url || "",
      })
      
      console.log('getGenerateJson响应:', data)
      
      if (data.code === 1) {
        commit('SET_GENERATE_JSON_DATA', data.data)
        return data.data
      } else {
        console.warn('getGenerateJson返回失败:', data.msg)
        commit('SET_GENERATE_JSON_DATA', null)
        return null
      }
    } catch (error) {
      console.error('调用getGenerateJson失败:', error)
      commit('SET_GENERATE_JSON_DATA', null)
      // 不抛出错误，避免阻塞用户操作
      return null
    } finally {
      commit('SET_GENERATE_JSON_LOADING', false)
    }
  },
  async generatePromptInBackground({ commit, state }, { jdUrl, cvUrl } = {}) {
    const maxRetries = 3
    const jobUrl = jdUrl || state.jd?.url
    const resumeUrl = cvUrl || state.cv?.url

    if (!jobUrl || !resumeUrl) {
      return null
    }

    commit('SET_PROMPT_ERROR', null)
    commit('SET_PROMPT_LOADING', true)

    try {
      const aiModule = await import('@/api/ai')
      const generatePrompt = aiModule.generatePrompt
      const requestData = {
        jobDescriptionContent: jobUrl,
        resumeContent: resumeUrl
      }

      let lastError = null

      for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
          const response = await generatePrompt(requestData)
          const data = response && response.data && response.data.data

          if (data && data.prompt) {
            commit('SET_PROMPT', data.prompt)
            if (data.interview_id) {
              commit('SET_INTERVIEW_ID', data.interview_id)
            }
            return data
          } else {
            lastError = new Error('Invalid prompt response')
            console.error(`generatePromptInBackground attempt ${attempt} failed:`, lastError)
          }
        } catch (error) {
          lastError = error
          console.error(`generatePromptInBackground attempt ${attempt} failed:`, error)
        }

        if (attempt < maxRetries) {
          await new Promise(resolve => setTimeout(resolve, attempt * 1000))
        }
      }

      if (lastError) {
        commit('SET_PROMPT_ERROR', lastError)
      }
      return null
    } catch (error) {
      console.error('generatePromptInBackground failed (module or unexpected error):', error)
      commit('SET_PROMPT_ERROR', error)
      return null
    } finally {
      commit('SET_PROMPT_LOADING', false)
    }
  },
  setCurrentInterviewJob({ commit }, job) {
    commit('SET_CURRENT_INTERVIEW_JOB', job)
  },
  clearCurrentInterviewJob({ commit }) {
    commit('CLEAR_CURRENT_INTERVIEW_JOB')
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}